import { Outlet } from 'react-router-dom';
import { PageWithSidebar } from '@/components/layout/PageWithSidebar';
import { Users, Calendar, MapPin } from 'lucide-react';

const partyLinks = [
  { name: 'All Parties', href: '/parties', icon: Users },
  { name: 'Events', href: '/parties/events', icon: Calendar },
  { name: 'Locations', href: '/parties/locations', icon: MapPin },
];

export function PartiesLayout() {
  return (
    <PageWithSidebar title="Parties" sidebarLinks={partyLinks}>
      <Outlet />
    </PageWithSidebar>
  );
}
